import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { WalletBtns, WalletContainer, WalletHeader } from "../walletStyles";
import { Box, Typography } from "@mui/material";
import { getCurrentUserInfo } from "../../../utils/UserAuth";
import { fetchAllBanks, getInitials } from "../../../screens/dashboard/DashboardUtils";
import { useNavigate } from "react-router-dom";
import { saveAvailableBanks } from "../../../redux/WalletSlice";

const WithdrawalDetails = ({ onClose, whiteBtnClick, greenBtnClick }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const adminData = getCurrentUserInfo();
	const { availableBanks } = useSelector((state) => state.wallet);

	const getAllBanks = async () => {
		try {
			const data = await fetchAllBanks();
			dispatch(saveAvailableBanks(data));
		} catch (error) {
			toast.error(error);
		}
	};

	const onUpdateAccountClick = () => {
		onClose();
		navigate("/profile", { state: { context: "bank" } });
	};

	const details = {
		bankName: adminData?.bankName,
		accountName: adminData?.accountName,
		accountNumber: adminData?.accountNumber,
	};

	useEffect(() => {
		if (availableBanks) {
			return;
		} else {
			getAllBanks();
		}
	}, []);

	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText='Send to Bank Account'
					onCloseModal={onClose}
					context='Verify bank information before you proceed.'
				/>
				<Box
					marginTop={3}
					border='1px solid #B8C8CF'
					bgcolor='#F6FAFB'
					borderRadius={2}
					padding={1.5}
					display='flex'
					gap={2}
					alignItems='center'>
					<Box
						height='40px'
						width='40px'
						display='flex'
						alignItems='center'
						justifyContent='center'
						borderRadius='9999px'
						color='white'
						bgcolor='#00525D'
						fontWeight='medium'
						fontSize='16px'>
						{getInitials(adminData?.accountName)}
					</Box>
					<Box display='flex' flexDirection='column' gap={0.3} color='black'>
						<Typography variant='body1' component='h6'>
							{adminData?.accountName || "N/A"}
						</Typography>
						<Typography variant='body1' component='p'>
							{adminData?.bankName || "N/A"}
						</Typography>
						<Typography variant='body1' component='p'>
							{adminData?.accountNumber || "N/A"}
						</Typography>
					</Box>
				</Box>
				<Box
					display='flex'
					justifyContent='flex-end'
					color='#00525D'
					fontSize='14px'
					marginTop={1}
					fontWeight={600}>
					<button onClick={onUpdateAccountClick}>Update Account</button>
				</Box>
				<WalletBtns
					whiteBtnClick={whiteBtnClick}
					isGreenBtnDisabled={!adminData?.accountNumber || !adminData?.bankName || !adminData?.accountName}
					greenBtnClick={() => greenBtnClick(details)}
				/>
			</>
		</WalletContainer>
	);
};

WithdrawalDetails.propTypes = {
	onClose: PropTypes.func,
	whiteBtnClick: PropTypes.func,
	greenBtnClick: PropTypes.func,
};

export default WithdrawalDetails;
